import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { AppDownloadButton } from '@babylon/medkit'
import { appStores, AppStoreLinks } from '@/config/constants'
import styles from './AppsInfo.module.scss'
import messages from './AppsInfo.messages'

interface Props {
  region: string
  onClick?: (device: keyof AppStoreLinks) => void
}

const getStoreUrl = (device: keyof AppStoreLinks, region: string) =>
  appStores[region][device]

const AppIcons = ({ onClick, region }: Props) => {
  const translate = useFormatMessage()

  const onStoreClick = (device: keyof AppStoreLinks) => {
    onClick?.(device)
  }

  return (
    <div className={styles.iconsWrapper} data-testid="appDownload-buttons">
      <AppDownloadButton
        href={getStoreUrl('apple', region)}
        title={translate(messages.iosDownloadAltText)}
        onClick={() => onStoreClick('apple')}
        vendor="AppStore"
      />
      <AppDownloadButton
        href={getStoreUrl('android', region)}
        title={translate(messages.iosDownloadAltText)}
        onClick={() => onStoreClick('android')}
        vendor="PlayStore"
      />
    </div>
  )
}

export default AppIcons
